import React from 'react';
import PropTypes from 'prop-types';
import {config} from 'aws-cognito-redux-saga';

class Auth extends React.Component {
    static propTypes = {
        getUser: PropTypes.func
    };

    UNSAFE_componentWillMount() {
        config.config.set({
            region: process.env.REACT_APP_AWS_COGNITO_REGION,
            IdentityPoolId: process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID,
            UserPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
            ClientId: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID
        });
        this.props.getUser();
    }

    render() {
        return null;
    }
}

export default Auth



// WEBPACK FOOTER //
// ./src/components/Auth/Auth.js